import { Pipe, PipeTransform } from '@angular/core';
import { DateService } from "./date.service";

/**
 * durationPipe
 * display au 00h00m value from a number of minutes.
 */
@Pipe({name: 'duration'})
export class DurationPipe implements PipeTransform {

    constructor(private dateService: DateService) {
    }

    public transform(minutes: any, xUnit?: string): string {
        let minutesData = minutes;

        if (minutes === "direct") {
            return "direct";
        }

        if (xUnit === "Hour") {

            minutesData = minutes * 60;
        }

        return this.dateService.getDuration(minutesData);
    }
}